
import * as React from 'react';
import Box from '@mui/material/Box';
import styled from 'styled-components';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import { SaveModel } from '@process-advisor/process-miner/eventLog/saveModel';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { UploadCSV } from '@process-advisor/process-miner/eventLog/uploadCSV';
import { EventLog } from '@process-advisor/process-miner/eventLog/eventLog';
import { Visualizer } from '@process-advisor/process-miner/components/visualizer'
import { processEventLogCSV } from '@process-advisor/process-miner/processMiner/processMiner'

const steps = ['Upload event log', 'Assign data types and map columns','Save data model'];

const StepVisibilityWrapper = styled.div<{ visible: boolean }>`
    display: ${({ visible }) => (visible ? 'block' : 'none')};
`;

export function ImportCSVStepper({app,mode,customerID,AppVersion,processLabel='Process'}) {
    const [activeStep, setActiveStep] = React.useState(0);
    const [nextDisabled, setNextDisabled] = React.useState<boolean>(true);
    const [activateAPI, setActivateAPI] = React.useState<boolean>(false);
    const [projectName, setProjectName] = React.useState<string>('');
    const [saveEventLog, setSaveEventLog] = React.useState(false);

    const loadData = async () => {
        await processEventLogCSV(customerID,projectName,saveEventLog,AppVersion)
        const sleep = ms => new Promise(r => setTimeout(r, ms));
        await sleep(2000)
        mode('Event Log Loaded')
    }

    const handleNext = () => {
        if (activeStep === steps.length - 1) {
            // display topbar, processvisualizer and sidebar
            loadData()
           
            // need to go back to Metricus.tsx and change the mode to Process Ming
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    React.useEffect(() => {
        // check so see if Visualizer already exists i.e. api has been initialised
        if (!apiProvider.getDiagram()) {
            setActivateAPI(true)
        }

    }, []);

    return (
        <Box display="flex" flexDirection="column"  sx={{ bgcolor: 'white' , width: '100%', pt: 5, pr: 20 }}>
            <Stepper activeStep={activeStep}>
                {steps.map((label) => {
                    const stepProps = {};
                    const labelProps = {};
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            <React.Fragment>
                <StepVisibilityWrapper visible={activeStep === 0}>
                    <UploadCSV nextDisabled={setNextDisabled} />
                </StepVisibilityWrapper>
                <StepVisibilityWrapper visible={activeStep === 1}>
                    <EventLog step={activeStep} nextDisabled={setNextDisabled} />
                </StepVisibilityWrapper>
                <StepVisibilityWrapper visible={activeStep === 2}>
                    <SaveModel nextDisabled={setNextDisabled} name={setProjectName} save={setSaveEventLog} currentTime={Date.now().toString()} activeStep={activeStep} processLabel={processLabel}/>
                </StepVisibilityWrapper>
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                    <Button color="inherit" disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1 }}>
                        Back
                    </Button>
                    <Box sx={{ flex: '1 1 auto' }} />

                    <Button onClick={handleNext} disabled={nextDisabled}>
                        {activeStep === steps.length - 1 ? `Generate Analysis Model` : 'Next'}
                    </Button>
                </Box>
            </React.Fragment>
            { activateAPI ? <Visualizer visible={false} app={app}/>:''}  
        </Box>
    );
}
